module.exports = __webpack_public_path__ + "static/media/Togekiss_gaussian2.022a0776.png";